import { Map } from 'immutable'
import { handleActions } from 'redux-actions'
import { combineReducers } from 'redux-immutable'
import * as constants from './constants'
import * as actions from './actions'

import { SocketState, ChannelState } from './models'

const socket = handleActions({
  [constants.AUTHENTICATE]: (state, action) => {
    const { clusterName } = action.payload
    if (!state.get(clusterName)) {
      return state.set(clusterName, SocketState())
    }
    return state
  },

  [constants.AUTHENTICATE_PENDING]: (state, action) => {
    const { clusterName } = action.payload
    return state.setIn([clusterName, 'authenticateStatus'], constants.AUTHENTICATE_PENDING)
  },

  [constants.AUTHENTICATE_FAILURE]: (state, action) => {
    const { clusterName } = action.payload
    return state.setIn([clusterName, 'authenticateStatus'], constants.AUTHENTICATE_FAILURE)
  },

  [constants.AUTHENTICATE_SUCCESS]: (state, action) => {
    const {
      clusterName,
      userIpAddress,
      userId,
      sessionToken,
    } = action.payload
    return state
      .setIn([clusterName, 'userIpAddress'], userIpAddress)
      .setIn([clusterName, 'userId'], userId)
      .setIn([clusterName, 'sessionToken'], sessionToken)
      .setIn([clusterName, 'authenticateStatus'], constants.AUTHENTICATE_SUCCESS)
      .setIn([clusterName, 'state'], constants.SOCKET_STATES.CONNECTING)
  },

  [constants.SOCKET_OPEN_EVENT_RECEIVED]: (state, action) => {
    const { clusterName } = action.payload
    const prevState = state.getIn([clusterName, 'reconnectStatus', 'prevState'])

    if (_.isNull(prevState)) {
      return state
        .setIn([clusterName, 'hasConnected'], true)
        .setIn([clusterName, 'state'], constants.SOCKET_STATES.OPEN)
        .setIn([clusterName, 'reconnectStatus', 'prevState'], constants.SOCKET_OPEN_EVENT_RECEIVED)
    }

    const shouldReload = [
      actions.socketCloseEventReceived.toString(),
      actions.socketErrorEventReceived.toString()
    ].includes(prevState)

    if (shouldReload) {
      return state
        .setIn([clusterName, 'hasConnected'], true)
        .setIn([clusterName, 'state'], constants.SOCKET_STATES.OPEN)
        .setIn([clusterName, 'reconnectStatus', 'prevState'], action.type)
    }

    return state.setIn([clusterName, 'hasConnected'], true)
  },

  [constants.SOCKET_CLOSE_EVENT_RECEIVED]: (state, action) => {
    const { clusterName } = action.payload
    return state
      .setIn([clusterName, 'state'], constants.SOCKET_STATES.CLOSED)
      .setIn([clusterName, 'reconnectStatus', 'prevState'], action.type)
  },

  [constants.SOCKET_ERROR_EVENT_RECEIVED]: (state, action) => {
    const { clusterName } = action.payload
    return state
      .setIn([clusterName, 'state'], constants.SOCKET_STATES.ERRORED)
      .setIn([clusterName, 'reconnectStatus', 'prevState'], action.type)
  },

  [constants.SOCKET_RECONNECT_ATTEMPT_QUEUED]: (state, action) => {
    const { clusterName, timeUntilReconnect } = action.payload
    return state.setIn([clusterName, 'timeUntilReconnect'], timeUntilReconnect)
  },

  [constants.SOCKET_RECONNECT_TIMER_TICKED]: (state, action) => {
    const { clusterName, timePassed } = action.payload
    return state.updateIn([clusterName, 'timeUntilReconnect'], (timeUntilReconnect) => timeUntilReconnect - timePassed)
  },

  [constants.CONNECT]: (state, action) => {
    const {
      clusterName,
      socket,
    } = action.payload
    return state.setIn([clusterName, 'socket'], socket)
  },

  [constants.JOIN_CHANNEL_PENDING]: (state, action) => {
    const {
      clusterName,
      channelName,
      channel,
      onMessageSubject,
    } = action.payload
    return state.setIn([clusterName, 'channels', channelName], ChannelState({
      channel,
      onMessageSubject,
      state: constants.CHANNEL_STATES.JOINING,
    }))
  },

  [constants.JOIN_CHANNEL_SUCCESS]: (state, action) => {
    const { clusterName, channelName } = action.payload
    return state.setIn([clusterName, 'channels', channelName, 'state'], constants.CHANNEL_STATES.JOINED)
  },

  [constants.JOIN_CHANNEL_FAILURE]: (state, action) => {
    const { clusterName, channelName } = action.payload
    return state.setIn([clusterName, 'channels', channelName, 'state'], constants.CHANNEL_STATES.ERRORED)
  },

  [constants.CHANNEL_ERROR_EVENT_RECEIVED]: (state, action) => {
    const { clusterName, channelName } = action.payload
    return state.setIn([clusterName, 'channels', channelName, 'state'], constants.CHANNEL_STATES.ERRORED)
  },

  [constants.CHANNEL_CLOSE_EVENT_RECEIVED]: (state, action) => {
    const { clusterName, channelName } = action.payload
    return state.setIn([clusterName, 'channels', channelName, 'state'], constants.CHANNEL_STATES.CLOSED)
  },
}, Map())

export default combineReducers({
  socket,
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/socket/reducer.js